import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { getCoreRowModel } from "./TableProps.fs.js";
import { append, ofArray } from "../Docs/fable_modules/fable-library.3.7.1/List.js";
import { createObj } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { createTable } from "@tanstack/table-core";

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Table.Table", void 0, Table);
}

export class Html {
    constructor() {
    }
}

export function Html$reflection() {
    return class_type("Feliz.TanStack.Table.Table.Html", void 0, Html);
}

export function Table_onStateChange_Z4395D14A(table) {
    return (updater) => {
        const next = Table_onStateChange_Z4395D14A(table);
        const state = table._obj.getState();
        const updatedState = ((typeof updater === 'function')) ? updater(state) : ({ ...state, ...updater });
        return table._obj.setOptions((prev) => {
            prev.state = updatedState;
            return { ...prev, ...table._obj.options, onStateChange: next };
        });
    };
}

export function Table_setOption(o, table) {
    const next = Table_onStateChange_Z4395D14A(table);
    return table._obj.setOptions((prev) => ({ ...prev, ...o, onStateChange: next }));
}

export function Table_init_Z5C3B000E(options) {
    const coreProps = ofArray([["getCoreRowModel", getCoreRowModel()], ["state", {}], ["onStateChange", () => {
    }], ["renderFallbackValue", null]]);
    const props = createObj(append(coreProps, options));
    const table = createTable(props);
    const state = table.initialState;
    table.setOptions((prev) => ({ ...prev, ...props, state: { ...state }, onStateChange: (() => {
    }) }));
    const data = props.data;
    let table_1;
    const b = { _obj: table };
    const a = {
        Data: data,
    };
    table_1 = ({ ...a, ...b });
    table_1._obj.setOptions((prev_1) => ({ ...prev_1, onStateChange: Table_onStateChange_Z4395D14A(table_1) }));
    return table_1;
}

export function Table_getContext_315F98D7(header) {
    return header.getContext();
}

export function Table_getContext_Z78EF7AD2(cell) {
    return cell.getContext();
}

export function Table_getVisibleCells_773C3262(row) {
    return row.getVisibleCells();
}

export function Table_getLeftVisibleCells_773C3262(row) {
    return row.getLeftVisibleCells();
}

export function Table_getCenterVisibleCells_773C3262(row) {
    return row.getCenterVisibleCells();
}

export function Table_getRightVisibleCells_773C3262(row) {
    return row.getRightVisibleCells();
}

export function Table_getHeaderGroups_Z4395D14A(table) {
    return table._obj.getHeaderGroups();
}

export function Table_getLeftHeaderGroups_Z4395D14A(table) {
    return table._obj.getLeftHeaderGroups();
}

export function Table_getCenterHeaderGroups_Z4395D14A(table) {
    return table._obj.getCenterHeaderGroups();
}

export function Table_getRightHeaderGroups_Z4395D14A(table) {
    return table._obj.getRightHeaderGroups();
}

export function Table_getFooterGroups_Z4395D14A(table) {
    return table._obj.getFooterGroups();
}

export function Table_getLeftFooterGroups_Z4395D14A(table) {
    return table._obj.getLeftFooterGroups();
}

export function Table_getCenterFooterGroups_Z4395D14A(table) {
    return table._obj.getCenterFooterGroups();
}

export function Table_getRightFooterGroups_Z4395D14A(table) {
    return table._obj.getRightFooterGroups();
}

export function Table_getAllLeafColumns_Z4395D14A(table) {
    return table._obj.getAllLeafColumns();
}

export function Table_getRowModel_Z4395D14A(table) {
    return table._obj.getRowModel();
}

export function Table_getPreFilteredRowModel_Z4395D14A(table) {
    return table._obj.getPreFilteredRowModel();
}

export function Html_flexRender_Z6DEE00B4(comp, context) {
    if ((typeof comp === 'function')) {
        return comp(context);
    }
    else {
        return comp;
    }
}

export function Html_flexRender_39247646(state, dispatch, comp, context) {
    if ((typeof comp === 'function')) {
        const obj = {
            state: state,
            dispatch: dispatch,
        };
        return comp({ ...context, ...obj });
    }
    else {
        return comp;
    }
}

//# sourceMappingURL=Table.fs.js.map
